import React, { useContext } from 'react';

type HeaderContextProps = {
  logout: () => Promise<void>;
  isPasswordAuth?: boolean;
  closeMobileMenu?: () => void;
};

const defaultContext = {
  logout: async () => {},
  isPasswordAuth: false,
  closeMobileMenu: undefined
};

export const HeaderContext =
  React.createContext<HeaderContextProps>(defaultContext);

export const useHeaderContext = () => useContext(HeaderContext);
